import { render, staticRenderFns } from "./EpDangerPenaltyReportTo.vue?vue&type=template&id=131a8074&scoped=true&"
import script from "./EpDangerPenaltyReportTo.vue?vue&type=script&lang=js&"
export * from "./EpDangerPenaltyReportTo.vue?vue&type=script&lang=js&"
import style0 from "./EpDangerPenaltyReportTo.vue?vue&type=style&index=0&id=131a8074&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "131a8074",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('131a8074')) {
      api.createRecord('131a8074', component.options)
    } else {
      api.reload('131a8074', component.options)
    }
    module.hot.accept("./EpDangerPenaltyReportTo.vue?vue&type=template&id=131a8074&scoped=true&", function () {
      api.rerender('131a8074', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/epreport/EpDangerPenaltyReportTo.vue"
export default component.exports